import React, { useEffect, useState } from "react";
import { Flame } from "lucide-react";
import api from "@/lib/api";

const short = (h) => (h ? `${h.slice(0, 6)}…${h.slice(-4)}` : "");

export const BurnsTicker = () => {
  const [burns, setBurns] = useState([]);
  useEffect(() => {
    api.get("/burns/public").then(({ data }) => setBurns(data)).catch(() => {});
  }, []);
  if (!burns.length) return null;
  const row = [...burns, ...burns];
  return (
    <div className="relative overflow-hidden border-y border-line bg-surface/60 py-2.5" data-testid="burns-ticker">
      <div className="flex w-max animate-marquee gap-8 whitespace-nowrap">
        {row.map((b, i) => (
          <div key={i} className="flex items-center gap-2 font-mono text-xs text-dust">
            <Flame size={12} className="text-pulp" />
            <span className={b.kind === "juice" ? "text-juice" : "text-pulp"}>${b.token}</span>
            <span className="text-cream">${b.amount_usd.toFixed(2)}</span>
            <span className="text-dust/70">burned</span>
            <span className="text-dust/50">{b.chain}</span>
            <span className="text-dust/40">{short(b.tx_hash)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
